import { render, staticRenderFns } from "./workStart3.vue?vue&type=template&id=74845788&scoped=true&"
import script from "./workStart3.vue?vue&type=script&lang=js&"
export * from "./workStart3.vue?vue&type=script&lang=js&"
import style0 from "./workStart3.vue?vue&type=style&index=0&id=74845788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74845788",
  null
  
)

export default component.exports